import { projectDataHasErrored, projectDataIsLoading } from './actions/ProjectFetchActions'
import { profileDataHasErrored, profileDataIsLoading } from './actions/ProfileFetchActions'
import { layoutDataHasErrored, layoutDataIsLoading } from './actions/LayoutFetchActions'
import { chapterDataHasErrored, chapterDataIsLoading } from './actions/ChapterFetchActions'
import { refreshTokenIntervalID } from "./actions/UserActions";
import { currentError } from './actions/ErrorActions';

import store from './configureStore'

// Reset data error and loading flag in store
export function resetDataFlag(data = false) {
    store.dispatch(projectDataHasErrored(data))
    store.dispatch(projectDataIsLoading(data))

    store.dispatch(profileDataHasErrored(data))
    store.dispatch(profileDataIsLoading(data))

    store.dispatch(chapterDataHasErrored(data))
    store.dispatch(chapterDataIsLoading(data))

    store.dispatch(layoutDataHasErrored(data))
    store.dispatch(layoutDataIsLoading(data))

    store.dispatch(refreshTokenIntervalID(0))

    store.dispatch(currentError({}))
}



// WEBPACK FOOTER //
// ./src/store/storeFunctionUtils.js